import {FEE_PAYMENT_STATUS} from './fee-payment-status.constants';

export const PAYMENT_FILTER_STATUS = {
  ALL: 'ALL',
  PAID: FEE_PAYMENT_STATUS.PAID,
  PENDING: FEE_PAYMENT_STATUS.PENDING
} as const;

export type PaymentFilterStatus = typeof PAYMENT_FILTER_STATUS[keyof typeof PAYMENT_FILTER_STATUS];

export const FEE_PAYMENT_FILTER_DIALOG_ACTION = {
  FILTER: 'filter',
  RESET: 'reset'
} as const;

export type FeePaymentFilterDialogAction =
  typeof FEE_PAYMENT_FILTER_DIALOG_ACTION[keyof typeof FEE_PAYMENT_FILTER_DIALOG_ACTION];
